import { useCallback, useContext, useState } from "react";
import { api } from "../../../api";
import { CustomerContext } from "../../../providers";
import { PageHeading } from "../../../externalComponents/PageHeading";
import { SettingsSidebar } from "../../../externalComponents/SettingsSidebar";
import { OverflowFrame } from "../../../externalComponents";
import { Heading } from "../../../externalComponents/tailwind/heading";
import { Text } from "../../../externalComponents/tailwind/text";
import { Input } from "../../../externalComponents/tailwind/input";
import {
  Description,
  Field,
  Legend,
} from "../../../externalComponents/tailwind/fieldset";

export default function CompanyNotificationsPage() {
  const { user, customer, shop } = useContext(CustomerContext);
  const [emails, setEmails] = useState(
    customer?.emailsForNotifications?.toString() ?? ""
  );
  const handleChangeEmails = useCallback((e) => {
    setEmails(e.target.value);
  }, []);
  const [isLoading, setIsLoading] = useState(false);

  const saveGeneralSettings = async () => {
    setIsLoading(true);

    await api.customer.update(customer.id, {
      emailsForNotifications: emails
        ? emails?.replaceAll(" ", "")?.split(",")
        : null,
    });

    setIsLoading(false);
  };

  return (
    <>
      <SettingsSidebar>
        <PageHeading
          title="Notifications"
          primaryAction="Save"
          handlePrimaryAction={saveGeneralSettings}
          isPrimaryLoading={isLoading}
        />
        <OverflowFrame>
          <div className="my-5">
            {customer?.isSubscribed &&
              (customer?.channelId360Dialog || customer?.waAccessToken) && (
                <Field>
                  <Legend>Email notifications</Legend>
                  <Description>
                    List of emails that will be notified when a new conversation
                    is initiated by a customer, separated by commas.
                  </Description>
                  <Input
                    placeholder="hello@gmail.com,contact@gmail.com"
                    value={emails}
                    onChange={handleChangeEmails}
                    autoComplete="off"
                  />
                </Field>
              )}
          </div>
        </OverflowFrame>
      </SettingsSidebar>
    </>
  );
}
